import { Pipe, PipeTransform } from '@angular/core';
import { isNumber } from 'lodash';

@Pipe({
	name: 'commonSwitchSignOfNumberFormatter',
})
export class CommonSwitchSignOfNumberFormatterPipe implements PipeTransform {
	transform(num: number) {
		return isNumber(num) && num !== 0 ? num * -1 : num;
	}
}
